import type { IconNode } from '../types';

/**
 * @name soccer-pitch
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgNXY1IiAvPgogIDxwYXRoIGQ9Ik0xMiAxNHY1IiAvPgogIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjIiIC8+CiAgPHBhdGggZD0iTTIgOWg0djZIMiIgLz4KICA8cGF0aCBkPSJNMyAxOWMtLjYgMC0xLS40LTEtMVY2YzAtLjYuNC0xIDEtMWgxOGMuNiAwIDEgLjQgMSAxdjEyYzAgLjYtLjQgMS0xIDFaIiAvPgogIDxwYXRoIGQ9Ik0yMiAxNWgtNFY5aDQiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/soccer-pitch
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const soccerPitch: IconNode = [
  ['path', { d: 'M12 5v5', key: '5zocua' }],
  ['path', { d: 'M12 14v5', key: '1qm3yk' }],
  ['circle', { cx: '12', cy: '12', r: '2', key: '1c9p78' }],
  ['path', { d: 'M2 9h4v6H2', key: '192yem' }],
  [
    'path',
    { d: 'M3 19c-.6 0-1-.4-1-1V6c0-.6.4-1 1-1h18c.6 0 1 .4 1 1v12c0 .6-.4 1-1 1Z', key: '1fv9jh' },
  ],
  ['path', { d: 'M22 15h-4V9h4', key: '1nvwh7' }],
];

export default soccerPitch;
